module.exports = __webpack_public_path__ + "static/media/logo.83014437.png";